import { render, staticRenderFns } from "./MewSupportComponent.vue?vue&type=template&id=03b9db2c&scoped=true&"
import script from "./MewSupportComponent.vue?vue&type=script&lang=js&"
export * from "./MewSupportComponent.vue?vue&type=script&lang=js&"
import style0 from "./MewSupportComponent.vue?vue&type=style&index=0&id=03b9db2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9db2c",
  null
  
)

export default component.exports